export default __webpack_public_path__ + "static/media/success.d1af3b08.svg";